// src/games/Quiz/rules.ts
// Regras puras do quiz (contrato P0): 10 pontos por acerto.
import type { iQuiz } from '../../interfaces/quiz';

export const POINTS_PER_ANSWER = 10;

export interface QuizAnswer {
  id_quiz: number;
  acertou: boolean;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function quizCorrectCount(answers: QuizAnswer[]): number {
  return answers.filter((answer) => answer.acertou).length;
}

export function quizPoints(answers: QuizAnswer[]): number {
  return quizCorrectCount(answers) * POINTS_PER_ANSWER;
}

/** `respondidos` salvo (portal ou app) → só perguntas deste quiz, sem repetição. */
export function readQuizAnswers(respondidos: unknown, questions: iQuiz[]): QuizAnswer[] {
  const ids = new Set(questions.map((question) => Number(question.id_quiz)));
  const seen = new Set<number>();
  const answers: QuizAnswer[] = [];
  (Array.isArray(respondidos) ? respondidos : []).forEach((entry) => {
    if (!isRecord(entry)) return;
    const id = Number(entry.id_quiz);
    if (!ids.has(id) || seen.has(id)) return;
    seen.add(id);
    answers.push({ id_quiz: id, acertou: entry.acertou === true });
  });
  return answers;
}

export function currentQuestionIndex(answers: QuizAnswer[], questions: iQuiz[]): number {
  const answered = new Set(answers.map((answer) => answer.id_quiz));
  const index = questions.findIndex((question) => !answered.has(Number(question.id_quiz)));
  return index === -1 ? questions.length : index;
}

export function isQuizComplete(answers: QuizAnswer[], questions: iQuiz[]): boolean {
  return questions.length > 0 && currentQuestionIndex(answers, questions) >= questions.length;
}

export function answerQuestion(answers: QuizAnswer[], question: iQuiz, alternativeIndex: number): QuizAnswer[] {
  const id = Number(question.id_quiz);
  if (answers.some((answer) => answer.id_quiz === id)) return answers;
  return [...answers, { id_quiz: id, acertou: question.alternatives[alternativeIndex]?.correct === true }];
}
